import { Stack, Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { Logo } from '~/shared/ui/Logo'
import { PageContainer } from '~/shared/ui/PageContainer'
import { Card } from './Card'
import { useCards } from './hooks/useCards'
import { LocaleForm } from './LocaleForm'
import { LocaleWrapper } from './styled'

function HomePage() {
  const cards = useCards()

  const { t } = useTranslation()

  return (
    <PageContainer title='Апарк'>
      <Stack
        spacing={4}
        alignItems='center'
        justifyContent='center'
        sx={{ margin: '20px 120px' }}
      >
        <Stack
          spacing={2}
          mb={'48px'}
          alignItems='center'
          sx={{
            marginBottom: '48px !important',
            position: 'relative',
            width: '100%',
          }}
        >
          <Logo />

          <Button sx={{ fontSize: '18px' }} href='https://apark.pro/'>
            {t('learn more about apark')}
          </Button>

          <LocaleWrapper>
            <LocaleForm />
          </LocaleWrapper>
        </Stack>
        <Grid container spacing={2} sx={{ marginTop: '0 !important' }}>
          {cards.map((card) => (
            <Grid key={card.title} xs={3} sx={{ flexGrow: 1 }}>
              <Card {...card} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </PageContainer>
  )
}

export default HomePage
